import { render, staticRenderFns } from "./ActListaProd.vue?vue&type=template&id=b28f47a6&scoped=true&"
import script from "./ActListaProd.vue?vue&type=script&lang=js&"
export * from "./ActListaProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f47a6",
  null
  
)

export default component.exports